<template>
  <div>
    <v-card>
      <v-card-title class="pb-0 mx-auto">
        <v-card-text class="pa-0">
          <TituloInfoHotel
            :in="data.hotel.in | formatDMY"
            :out="data.hotel.out | formatDMY"
            :diff="_$diffDias(data.hotel.in, data.hotel.out)"
            :nombre="data.hotel.nombre"
          >
          </TituloInfoHotel>
        </v-card-text>
      </v-card-title>

      <v-card-text class="pa-1">
        <ul class="ul-not-dot-as mb-2">
          <li
            v-for="(hab, inhab) in data.hotel.habitaciones"
            v-bind:key="inhab + 'habitacion'"
            class="pa-1 hover-hab-as"
          >
            <p class="body-1 mb-1 font-weight-medium">
              <span class="caption font-weight-light">Habitación</span> {{ hab.habitacion.nombre.toUpperCase() }}
            </p>
            <p class="font-weight-light caption my-2 ml-2">
              {{ armarOcupacionCliente(hab.habitacion.tarifas.tarifa["@attributes"].adl, hab.habitacion.menores) }}
              <span class="float-right">
                {{ hab.habitacion.tarifas.tarifa.moneda }}
                {{ hab.habitacion.tarifas.tarifa.venta }}

                <span @click="eliminarHabitacion(hab.habitacion, data.hotel.unico_carrito)" v-show="editable">
                  <v-icon class="caption mb-1 cur-pointer" color="red">fas fa-trash-alt</v-icon>
                </span>
              </span>
            </p>
            <ul class="ul-not-dot-as mb-2">
              <li v-for="(p, pinx) in hab.habitacion.tickets">
                <p class="caption font-weight-medium mb-0">
                  <span class="caption font-weight-light">Pase</span> {{ p.nombre.toUpperCase() }}
                </p>
                <p class="font-weight-light ml-2 my-2 caption mb-0">
                  {{ p.tarifas.totales["@attributes"].adl }} Adultos
                  <span v-if="p.tarifas.totales['@attributes'].chd > 0"
                    >{{ p.tarifas.totales["@attributes"].chd }} Niños</span
                  >
                  <span v-if="p.tarifas.totales['@attributes'].bebe > 0"
                    >{{ p.tarifas.totales["@attributes"].bebe }} Infantes</span
                  >
                  <span class="float-right">
                    {{ p.tarifas.totales.moneda }} {{ p.tarifas.totales.venta }}
                    <span @click="eliminarTicket(hab.habitacion.comparador)" v-if="editableAdicional">
                      <v-icon class="caption mb-1 cur-pointer" color="red">fas fa-trash-alt</v-icon>
                    </span>
                  </span>
                </p>
              </li>
              <li v-for="(p, pinx) in hab.habitacion.comidas">
                <p class="caption font-weight-medium mb-0">
                  <span class="caption font-weight-light">Régimen</span> {{ p.nombre.toUpperCase() }}
                </p>
                <p class="font-weight-light ml-2 my-2 caption mb-0">
                  {{
                    armarOcupacionCliente(
                      hab.habitacion.tarifas.tarifa["@attributes"].adl,
                      hab.habitacion.menores,
                      true
                    )
                  }}
                  <span class="float-right">
                    <span v-for="(t, tin) in p.tarifas.tarifa">
                      <span v-if="t['@attributes'].tipo == 'total'"> {{ t.moneda }} {{ t.venta }} </span>
                    </span>
                    <span @click="eliminarComida(hab.habitacion.comparador)" v-if="editableAdicional">
                      <v-icon class="caption mb-1 cur-pointer" color="red">fas fa-trash-alt</v-icon>
                    </span>
                  </span>
                </p>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="ul-not-dot-as mb-2" v-if="data.traslado">
          <li class="pa-1 hover-hab-as" v-for="(t, tin) in data.traslado.traslados">
            <p class="caption font-weight-regular mb-0 text-uppercase">
              {{ t.nombreTraslado }}
            </p>
            <p class="font-weight-light ml-2 my-2 caption mb-0">
              {{ t.tarifas.totales["@attributes"].adl }} Adultos
              <span v-if="t.tarifas.totales['@attributes'].chd > 0"
                >{{ t.tarifas.totales["@attributes"].chd }} Niños</span
              >
              <span v-if="t.tarifas.totales['@attributes'].bebe > 0"
                >{{ t.tarifas.totales["@attributes"].bebe }} Infantes</span
              >
              <span class="float-right">
                {{ t.tarifas.totales.moneda }} {{ t.tarifas.totales.venta }}
                <span v-if="editableAdicional">
                  <v-icon
                    class="caption mb-1 cur-pointer"
                    color="red"
                    @click="borrarTraslado(data.traslado.unico_hotel, t.idTarifa)"
                    >fas fa-trash-alt</v-icon
                  >
                </span>
              </span>
            </p>
            <p class="font-weight-light ml-2 my-2 caption mb-0" v-if="t.llegada">
              El vuelo de llegada para este traslado es
              {{ t.llegada | formatDMY }}, número de vuelo
              {{ t.nroVueloLlegada }}
            </p>
            <p class="font-weight-light ml-2 my-2 caption mb-0" v-if="t.salida">
              El vuelo de salida para este traslado es
              {{ t.salida | formatDMY }}, número de vuelo {{ t.nroVueloSalida }}
            </p>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TituloInfoHotel from "@/components/utiles/TituloInfoHotel.vue"
export default {
  name: "carritoPanelHotel",
  props: ["data"],
  components: {
    TituloInfoHotel
  },
  mounted() {},
  created() {},
  methods: {
    eliminarHabitacion(habitacion, unico) {
      var eliminar = {
        unico: unico,
        clase: habitacion.clase,
        codigo: habitacion.codigo,
        ocupacion: habitacion.ocupacion
      }
      const rs = this.$store.dispatch("carrito/habitacion2Eliminar", eliminar)
      rs.then(response => {
        this.manejoEleminarHab(response)
      })
    },
    manejoEleminarHab(response) {
      if (!response) {
        this.showToasted(
          "Ocurrió un error al eliminar una habitación, por favor contacte al administrador.",
          "error",
          3000
        )
        this._$goToInicio()
        return
      }
      this.showToasted("Habitación eliminada.", "success", 2000)
    },
    async eliminarTicket(comparador) {
      let toas = { tipo: "error", mensaje: "No se pudo eliminar el pase" }
      const rs = await this.$store.dispatch("carrito/borrarPase2Habitacion", comparador)
      if (rs) {
        toas = { tipo: "success", mensaje: "Pase eliminado" }
      }
      this.showToasted(toas.mensaje, toas.tipo)
    },
    async borrarTraslado(unico_carrito, idTarifa) {
      let toas = {
        tipo: "error",
        mensaje: "No se pudo eliminar el traslado a el hotel"
      }
      const rs = await this.$store.dispatch("carrito/borrarTraslado", {
        unico: unico_carrito,
        idTarifa: idTarifa
      })
      if (rs) {
        toas = { tipo: "success", mensaje: "Traslado eliminado del carrito" }
      }
      this.showToasted(toas.mensaje, toas.tipo)
    },
    async eliminarComida(comparador) {
      let toas = { tipo: "error", mensaje: "No se pudo eliminar la comida" }
      const rs = await this.$store.dispatch("carrito/borrarComida2Habitacion", comparador)
      if (rs) {
        toas = { tipo: "success", mensaje: "Comida eliminada" }
      }
      this.showToasted(toas.mensaje, toas.tipo)
    }
  },
  computed: {
    editable: function() {
      switch (this.$route.name) {
        case "resultadoHoteles":
        case "hotelesCupos":
          return true
          break

        default:
          return false
          break
      }
    },
    editableAdicional: function() {
      switch (this.$route.name) {
        case "adicionalesHoteleria":
          return true
          break

        default:
          return false
          break
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped>
.hover-hab-as:hover {
  background-color: #eceff1;
}
</style>
